function updateBlockLanguage(_ref) {
  var editor = _ref.editor,
      block = _ref.block,
      language = _ref.language;
  block.nodes.forEach(function (node) {
    editor.setNodeByKey(node.key, {
      data: node.data.set('language', language)
    });
  });
  return editor;
}

export default updateBlockLanguage;